import { render, staticRenderFns } from "./MarkupPins.vue?vue&type=template&id=64bf1629&"
import script from "./MarkupPins.vue?vue&type=script&lang=js&"
export * from "./MarkupPins.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports